/// <reference path="../../inforShared/js/globalize.js" />
/// <reference path="../../../../core/Frame.js" />

/*!
 * jQuery UI Tabs 1.14.0
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Tabs
//>>group: Widgets
//>>description: Transforms a set of container elements into a tab structure.
//>>docs: http://api.jqueryui.com/tabs/
//>>demos: http://jqueryui.com/tabs/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/tabs.css
//>>css.theme: ../../themes/base/theme.css

( function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [
			"jquery",
			"../keycode",
			"../unique-id",
			"../version",
			"../widget"
		], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )

/** UPGRADE NOTE:
  Update "ui.tabs" widget with the latest tab widget from JQuery-ui code base
  https://github.com/jquery/jquery-ui/blob/main/ui/widgets/tabs.js
**/
( function( $ ) {
"use strict";
$.widget( "ui.tabs", { 
	version: "@1.14.0",
	delay: 300,
	options: {
		active: null,
		classes: {
			"ui-tabs": "ui-corner-all",
			"ui-tabs-nav": "ui-corner-all",
			"ui-tabs-panel": "ui-corner-bottom",
			"ui-tabs-tab": "ui-corner-top"
		},
		collapsible: false,
		event: "click",
		heightStyle: "content",
		hide: null,
		show: null,

		// Callbacks
		activate: null,
		beforeActivate: null,
		beforeLoad: null,
		load: null
	},

	_isLocal: ( function() {
		var rhash = /#.*$/;

		return function( anchor ) {
			var anchorUrl, locationUrl;

			anchorUrl = anchor.href.replace( rhash, "" );
			locationUrl = location.href.replace( rhash, "" );

			// Decoding may throw an error if the URL isn't UTF-8 (#9518)
			try {
				anchorUrl = decodeURIComponent( anchorUrl );
			} catch ( error ) {}
			try {
				locationUrl = decodeURIComponent( locationUrl );
			} catch ( error ) {}

			return anchor.hash.length > 1 && anchorUrl === locationUrl;
		};
	} )(),

	_create: function() {
		var that = this,
			options = this.options;

		this.running = false;

		this._addClass( "ui-tabs", "ui-widget ui-widget-content" );
		this._toggleClass( "ui-tabs-collapsible", null, options.collapsible );

		this._processTabs();
		options.active = this._initialActive();

		// Take disabling tabs via class attribute from HTML
		// into account and update option properly.
		if ( Array.isArray( options.disabled ) ) {
			options.disabled = $.uniqueSort( options.disabled.concat(
				$.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
					return that.tabs.index( li );
				} )
			) ).sort();
		}

		// Check for length avoids error when initializing empty list
		if ( this.options.active !== false && this.anchors.length ) {
			this.active = this._findActive( options.active );
		} else {
			this.active = $();
		}

		this._refresh();

		if ( this.active.length ) {
			this.load( options.active );
		}
	},

	_initialActive: function() {
		var active = this.options.active,
			collapsible = this.options.collapsible,
			locationHash = location.hash.substring( 1 );

		if ( active === null ) {

			// check the fragment identifier in the URL
			if ( locationHash ) {
				this.tabs.each( function( i, tab ) {
					if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
						active = i;
						return false;
					}
				} );
			}

			// Check for a tab marked active via a class
			if ( active === null ) {
				active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
			}

			// No active tab, set to false
			if ( active === null || active === -1 ) {
				active = this.tabs.length ? 0 : false;
			}
		}

		// Handle numbers: negative, out of range
		if ( active !== false ) {
			active = this.tabs.index( this.tabs.eq( active ) );
			if ( active === -1 ) {
				active = collapsible ? false : 0;
			}
		}

		// Don't allow collapsible: false and active: false
		if ( !collapsible && active === false && this.anchors.length ) {
			active = 0;
		}

		return active;
	},

	_getCreateEventData: function() {
		return {
			tab: this.active,
			panel: !this.active.length ? $() : this._getPanelForTab( this.active )
		};
	},

	_tabKeydown: function( event ) {
		var focusedTab = $( this.document[ 0 ].activeElement ).closest( "li" ),
			selectedIndex = this.tabs.index( focusedTab ),
			goingForward = true;

		if ( this._handlePageNav( event ) ) {
			return;
		}

		switch ( event.keyCode ) {
		case $.ui.keyCode.RIGHT:
		case $.ui.keyCode.DOWN:
			selectedIndex++;
			break;
		case $.ui.keyCode.UP:
		case $.ui.keyCode.LEFT:
			goingForward = false;
			selectedIndex--;
			break;
		case $.ui.keyCode.END:
			selectedIndex = this.anchors.length - 1;
			break;
		case $.ui.keyCode.HOME:
			selectedIndex = 0;
			break;
		case $.ui.keyCode.SPACE:

			// Activate only, no collapsing
			event.preventDefault();
			clearTimeout( this.activating );
			this._activate( selectedIndex );
			return;
		case $.ui.keyCode.ENTER:

			// Toggle (cancel delayed activation, allow collapsing)
			event.preventDefault();
			clearTimeout( this.activating );

			// Determine if we should collapse or activate
			this._activate( selectedIndex === this.options.active ? false : selectedIndex );
			return;
		default:
			return;
		}

		// Focus the appropriate tab, based on which key was pressed
		event.preventDefault();
		clearTimeout( this.activating );
		selectedIndex = this._focusNextTab( selectedIndex, goingForward );

		// Navigating with control/command key will prevent automatic activation
		if ( !event.ctrlKey && !event.metaKey ) {

			// Update aria-selected immediately so that AT think the tab is already selected.
			// Otherwise AT may confuse the user by stating that they need to activate the tab,
			// but the tab will already be activated by the time the announcement finishes.
			focusedTab.attr( "aria-selected", "false" );
			this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

			this.activating = this._delay( function() {
				this.option( "active", selectedIndex );
			}, this.delay );
		}
	},

	_panelKeydown: function( event ) {
		if ( this._handlePageNav( event ) ) {
			return;
		}

		// Ctrl+up moves focus to the current tab
		if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
			event.preventDefault();
			this.active.trigger( "focus" );
		}
	},

	// Alt+page up/down moves focus to the previous/next tab (and activates)
	_handlePageNav: function( event ) {
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
			this._activate( this._focusNextTab( this.options.active - 1, false ) );
			return true;
		}
		if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
			this._activate( this._focusNextTab( this.options.active + 1, true ) );
			return true;
		}
	},

	_findNextTab: function( index, goingForward ) {
		var lastTabIndex = this.tabs.length - 1;

		function constrain() {
			if ( index > lastTabIndex ) {
				index = 0;
			}
			if ( index < 0 ) {
				index = lastTabIndex;
			}
			return index;
		}

		while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
			index = goingForward ? index + 1 : index - 1;
		}

		return index;
	},

	_focusNextTab: function( index, goingForward ) {
		index = this._findNextTab( index, goingForward );
		this.tabs.eq( index ).trigger( "focus" );
		return index;
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		this._super( key, value );

		if ( key === "collapsible" ) {
			this._toggleClass( "ui-tabs-collapsible", null, value );

			// Setting collapsible: false while collapsed; open first panel
			if ( !value && this.options.active === false ) {
				this._activate( 0 );
			}
		}

		if ( key === "event" ) {
			this._setupEvents( value );
		}

		if ( key === "heightStyle" ) {
			this._setupHeightStyle( value );
		}
	},

	_sanitizeSelector: function( hash ) {
		return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
	},

	refresh: function() {
		var options = this.options,
			lis = this.tablist.children( ":has(a[href])" );

		// Get disabled tabs from class attribute from HTML
		// this will get converted to a boolean if needed in _refresh()
		options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
			return lis.index( tab );
		} );

		this._processTabs();

		// Was collapsed or no tabs
		if ( options.active === false || !this.anchors.length ) {
			options.active = false;
			this.active = $();

		// was active, but active tab is gone
		} else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {

			// all remaining tabs are disabled
			if ( this.tabs.length === options.disabled.length ) {
				options.active = false;
				this.active = $();

			// activate previous tab
			} else {
				this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
			}

		// was active, active tab still exists
		} else {

			// make sure active index is correct
			options.active = this.tabs.index( this.active );
		}

		this._refresh();
	},

	_refresh: function() {
		this._setOptionDisabled( this.options.disabled );
		this._setupEvents( this.options.event );
		this._setupHeightStyle( this.options.heightStyle );

		this.tabs.not( this.active ).attr( {
			"aria-selected": "false",
			"aria-expanded": "false",
			tabIndex: -1
		} );
		this.panels.not( this._getPanelForTab( this.active ) )
			.hide()
			.attr( {
				"aria-hidden": "true"
			} );

		// Make sure one tab is in the tab order
		if ( !this.active.length ) {
			this.tabs.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
			this._addClass( this.active, "ui-tabs-active", "ui-state-active" );
			this._getPanelForTab( this.active )
				.show()
				.attr( {
					"aria-hidden": "false"
				} );
		}
	},

	_processTabs: function() {
		var that = this,
			prevTabs = this.tabs,
			prevAnchors = this.anchors,
			prevPanels = this.panels;

		this.tablist = this._getList().attr( "role", "tablist" );
		this._addClass( this.tablist, "ui-tabs-nav",
			"ui-helper-reset ui-helper-clearfix ui-widget-header" );

		// Prevent users from focusing disabled tabs via click
		this.tablist
			.on( "mousedown" + this.eventNamespace, "> li", function( event ) {
				if ( $( this ).is( ".ui-state-disabled" ) ) {
					event.preventDefault();
				}
			} );

		this.tabs = this.tablist.find( "> li:has(a[href])" )
			.attr( {
				role: "tab",
				tabIndex: -1
			} );
		this._addClass( this.tabs, "ui-tabs-tab", "ui-state-default" );

		this.anchors = this.tabs.map( function() {
			return $( "a", this )[ 0 ];
		} )
			.attr( {
				tabIndex: -1
			} );
		this._addClass( this.anchors, "ui-tabs-anchor" );

		this.panels = $();

		this.anchors.each( function( i, anchor ) {
			var selector, panel, panelId,
				anchorId = $( anchor ).uniqueId().attr( "id" ),
				tab = $( anchor ).closest( "li" ),
				originalAriaControls = tab.attr( "aria-controls" );

			// Inline tab
			if ( that._isLocal( anchor ) ) {
				selector = anchor.hash;
				panelId = selector.substring( 1 );
				panel = that.element.find( that._sanitizeSelector( selector ) );

			// remote tab
			} else {

				// If the tab doesn't already have aria-controls,
				// generate an id by using a throw-away element
				panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
				selector = "#" + panelId;
				panel = that.element.find( selector );
				if ( !panel.length ) {
					panel = that._createPanel( panelId );
					panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
				}
				panel.attr( "aria-live", "polite" );
			}

			if ( panel.length ) {
				that.panels = that.panels.add( panel );
			}
			if ( originalAriaControls ) {
				tab.data( "ui-tabs-aria-controls", originalAriaControls );
			}
			tab.attr( {
				"aria-controls": panelId,
				"aria-labelledby": anchorId
			} );
			panel.attr( "aria-labelledby", anchorId );
		} );

		this.panels.attr( "role", "tabpanel" );
		this._addClass( this.panels, "ui-tabs-panel", "ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevTabs ) {
			this._off( prevTabs.not( this.tabs ) );
			this._off( prevAnchors.not( this.anchors ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	// Allow overriding how to find the list for rare usage scenarios (#7715)
	_getList: function() {
		return this.tablist || this.element.find( "ol, ul" ).eq( 0 );
	},

	_createPanel: function( id ) {
		return $( "<div>" )
			.attr( "id", id )
			.data( "ui-tabs-destroy", true );
	},

	_setOptionDisabled: function( disabled ) {
		var currentItem, li, i;

		if ( Array.isArray( disabled ) ) {
			if ( !disabled.length ) {
				disabled = false;
			} else if ( disabled.length === this.anchors.length ) {
				disabled = true;
			}
		}

		// Disable tabs
		for ( i = 0; ( li = this.tabs[ i ] ); i++ ) {
			currentItem = $( li );
			if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
				currentItem.attr( "aria-disabled", "true" );
				this._addClass( currentItem, null, "ui-state-disabled" );
			} else {
				currentItem.removeAttr( "aria-disabled" );
				this._removeClass( currentItem, null, "ui-state-disabled" );
			}
		}

		this.options.disabled = disabled;

		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null,
			disabled === true );
	},

	_setupEvents: function( event ) {
		var events = {};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.anchors.add( this.tabs ).add( this.panels ) );

		// Always prevent the default action, even when disabled
		this._on( true, this.anchors, {
			click: function( event ) {
				event.preventDefault();
			}
		} );
		this._on( this.anchors, events );
		this._on( this.tabs, { keydown: "_tabKeydown" } );
		this._on( this.panels, { keydown: "_panelKeydown" } );

		this._focusable( this.tabs );
		this._hoverable( this.tabs );
	},

	_setupHeightStyle: function( heightStyle ) {
		var maxHeight,
			parent = this.element.parent();

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			maxHeight -= this.element.outerHeight() - this.element.height();

			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.element.children().not( this.panels ).each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.panels.each( function() {
				$( this ).height( Math.max( 0, maxHeight -
					$( this ).innerHeight() + $( this ).height() ) );
			} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.panels.each( function() {
				maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
			} ).height( maxHeight );
		}
	},

	_eventHandler: function( event ) {
		var options = this.options,
			active = this.active,
			anchor = $( event.currentTarget ),
			tab = anchor.closest( "li" ),
			clickedIsActive = tab[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : this._getPanelForTab( tab ),
			toHide = !active.length ? $() : this._getPanelForTab( active ),
			eventData = {
				oldTab: active,
				oldPanel: toHide,
				newTab: collapsing ? $() : tab,
				newPanel: toShow
			};

		event.preventDefault();

		if ( tab.hasClass( "ui-state-disabled" ) ||

				// tab is already loading
				tab.hasClass( "ui-tabs-loading" ) ||

				// can't switch durning an animation
				this.running ||

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.tabs.index( tab );

		this.active = clickedIsActive ? $() : tab;
		if ( this.xhr ) {
			this.xhr.abort();
		}

		if ( !toHide.length && !toShow.length ) {
			$.error( "jQuery UI Tabs: Mismatching fragment identifier." );
		}

		if ( toShow.length ) {
			this.load( this.tabs.index( tab ), event );
		}
		this._toggle( event, eventData );
	},

	// Handles show/hide for selecting tabs
	_toggle: function( event, eventData ) {
		var that = this,
			toShow = eventData.newPanel,
			toHide = eventData.oldPanel;

		this.running = true;

		function complete() {
			that.running = false;
			that._trigger( "activate", event, eventData );
      that._trigger( "show", event, eventData );
		}

		function show() {
			that._addClass( eventData.newTab.closest( "li" ), "ui-tabs-active", "ui-state-active" );

			if ( toShow.length && that.options.show ) {
				that._show( toShow, that.options.show, complete );
			} else {
				toShow.show();
				complete();
			}
		}

		// Start out by hiding, then showing, then completing
		if ( toHide.length && this.options.hide ) {
			this._hide( toHide, this.options.hide, function() {
				that._removeClass( eventData.oldTab.closest( "li" ),
					"ui-tabs-active", "ui-state-active" );
				show();
			} );
		} else {
			this._removeClass( eventData.oldTab.closest( "li" ),
				"ui-tabs-active", "ui-state-active" );
			toHide.hide();
			show();
		}

		toHide.attr( "aria-hidden", "true" );
		eventData.oldTab.attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// If we're switching tabs, remove the old tab from the tab order.
		// If we're opening from collapsed state, remove the previous tab from the tab order.
		// If we're collapsing, then keep the collapsing tab in the tab order.
		if ( toShow.length && toHide.length ) {
			eventData.oldTab.attr( "tabIndex", -1 );
		} else if ( toShow.length ) {
			this.tabs.filter( function() {
				return $( this ).attr( "tabIndex" ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow.attr( "aria-hidden", "false" );
		eventData.newTab.attr( {
			"aria-selected": "true",
			"aria-expanded": "true",
			tabIndex: 0
		} );
	},

	_activate: function( index ) {
		var anchor,
			active = this._findActive( index );
		
		// Trying to collapse, simulate a click on the current active header
		if ( !active.length ) {
			active = this.active;
		}

		anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
		this._eventHandler( {
			target: anchor,
			currentTarget: anchor,
			preventDefault: $.noop
		} );

		this._trigger( "activate", null, {newTab: active} );
	},

	_findActive: function( index ) {
    if (typeof index === "string") {
      var viewTab = this.anchors.filter( "[href$='" + CSS.escape( index ) + "']" ).parent();
      return viewTab;
    }
    else
		  return index === false ? $() : this.tabs.eq( index );
	},

	_getIndex: function( index ) {

		// meta-function to give users option to provide a href string instead of a numerical index.
		if ( typeof index === "string" ) {
			index = this.anchors.index( this.anchors.filter( "[href$='" +
				CSS.escape( index ) + "']" ) );
		}

		return index;
	},

	_destroy: function() {
		if ( this.xhr ) {
			this.xhr.abort();
		}

		this.tablist
			.removeAttr( "role" )
			.off( this.eventNamespace );

		this.anchors
			.removeAttr( "role tabIndex" )
			.removeUniqueId();

		this.tabs.add( this.panels ).each( function() {
			if ( $.data( this, "ui-tabs-destroy" ) ) {
				$( this ).remove();
			} else {
				$( this ).removeAttr( "role tabIndex " +
					"aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded" );
			}
		} );

		this.tabs.each( function() {
			var li = $( this ),
				prev = li.data( "ui-tabs-aria-controls" );
			if ( prev ) {
				li
					.attr( "aria-controls", prev )
					.removeData( "ui-tabs-aria-controls" );
			} else {
				li.removeAttr( "aria-controls" );
			}
		} );

		this.panels.show();

		if ( this.options.heightStyle !== "content" ) {
			this.panels.css( "height", "" );
		}
	},

	enable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === false ) {
			return;
		}

		if ( index === undefined ) {
			disabled = false;
		} else {
			index = this._getIndex( index );
			if ( Array.isArray( disabled ) ) {
				disabled = $.map( disabled, function( num ) {
					return num !== index ? num : null;
				} );
			} else {
				disabled = $.map( this.tabs, function( li, num ) {
					return num !== index ? num : null;
				} );
			}
		}
		this._setOptionDisabled( disabled );
	},

	disable: function( index ) {
		var disabled = this.options.disabled;
		if ( disabled === true ) {
			return;
		}

		if ( index === undefined ) {
			disabled = true;
		} else {
			index = this._getIndex( index );
			if ( $.inArray( index, disabled ) !== -1 ) {
				return;
			}
			if ( Array.isArray( disabled ) ) {
				disabled = $.merge( [ index ], disabled ).sort();
			} else {
				disabled = [ index ];
			}
		}
		this._setOptionDisabled( disabled );
	},

	load: function( index, event ) {
		index = this._getIndex( index );
		var that = this,
			tab = this.tabs.eq( index ),
			anchor = tab.find( ".ui-tabs-anchor" ),
			panel = this._getPanelForTab( tab ),
			eventData = {
				tab: tab,
				panel: panel
			},
			complete = function( jqXHR, status ) {
				if ( status === "abort" ) {
					that.panels.stop( false, true );
				}

				that._removeClass( tab, "ui-tabs-loading" );
				panel.removeAttr( "aria-busy" );

				if ( jqXHR === that.xhr ) {
					delete that.xhr;
				}
			};

		// Not remote
		if ( this._isLocal( anchor[ 0 ] ) ) {
			return;
		}

		this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

		if ( this.xhr.statusText !== "canceled" ) {
			this._addClass( tab, "ui-tabs-loading" );
			panel.attr( "aria-busy", "true" );

			this.xhr
				.done( function( response, status, jqXHR ) {
					panel.html( response );
					that._trigger( "load", event, eventData );

					complete( jqXHR, status );
				} )
				.fail( function( jqXHR, status ) {
					complete( jqXHR, status );
				} );
		}
	},

	_ajaxSettings: function( anchor, event, eventData ) {
		var that = this;
		return {
			url: anchor.attr( "href" ),
			beforeSend: function( jqXHR, settings ) {
				return that._trigger( "beforeLoad", event,
					$.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
			}
		};
	},

	_getPanelForTab: function( tab ) {
		var id = $( tab ).attr( "aria-controls" );
		return this.element.find( this._sanitizeSelector( "#" + id ) );
	}
} );

// DEPRECATED
// TODO: Switch return back to widget declaration at top of file when this is removed
if ( $.uiBackCompat === true ) {
	// Backcompat for ui-tab class (now ui-tabs-tab)
	$.widget( "ui.tabs", $.ui.tabs, {
		_processTabs: function() {
			this._superApply( arguments );
			this._addClass( this.tabs, "ui-tab" );
		}
	} );
}

return $.ui.tabs;

} );

/*
 * Infor Tabset Control
 */
(function($) {
  $.widget("ui.inforTabset", {
    options: {
      editable: false,
      closable: false,
      sortable: false,
      addButton: false,
      rename: null,
      add: null,
      close: null,
      sort: null,
      showLoadingIndicator: false,
      animate: false,
      fillToBottom: true,
      toolTips: {
        addButton: null,
        closeButton: null
      },
      moduleTabs: false,
      verticalTabs: false,
      contextMenuOptions: [
        {
          label: Globalize.localize("CloseTab"),
          href: "#close"
        },
        {
          label: Globalize.localize("CloseOtherTabs"),
          href: "#closeOthers"
        }
      ],
      // {label: Globalize.localize("CloseAllTabs"), href: "#closeAll"}

      /** UPGRADE NOTE:
        Updated callbacks from the latest JQuery-ui version
      **/
      activate: null,
      beforeActivate: null,
      beforeLoad: null,
      load: null
     
    },
    _init: function() {
      var o = this.options,
        $tabs = $(this.element),
        self = this,
        contH,
        tabObj,
        parents;
      //localize tooltips
      if (!o.toolTips.addButton) {
        o.toolTips.addButton = Globalize.localize("CreateTab");
      }
      if (!o.toolTips.closeButton) {
        o.toolTips.closeButton = Globalize.localize("CloseTab");
      }
      //Add close buttons if required
      if (o.closable) {
        this._addCloseButton($tabs, o);
      }
      if (o.editable) {
        this._addEditors($tabs, null, false, o);
      }
      if (o.addButton) {
        this._addAddButton($tabs, o);
      }
      $tabs.tabs({
        /** UPGRADE NOTE:
          `spinner` is deprecated in jQuery UI 1.9.0 and removed in 1.10.0
          Use the `beforeLoad` instead.
          **/
        beforeLoad: o.showLoadingIndicator
          ? "<div class='inforBusyIndicator large'></div>"
          : ""
      });
      if ($(this.element).hasClass("inforModuleTabs")) {
        this.options.moduleTabs = true;
      }
      this._addButtons($tabs, o);
      //hide any visibile tooltips..
      $tabs.bind("tabsselect", function() {
        $("#inforTooltip, #validation-errors, #tooltip").addClass("is-hidden");
        $("#dropdown-list, #multiselect-list").remove();
        $(".slick-columnpicker").hide();
        if (o.editable) {
          $("input.inforTabHeaderEditor").trigger("blur");
        }
      });
      //refresh grids on show
      $tabs.bind("tabsshow", function(event, ui) {
        self._sizeInternalElements($(ui.newPanel), $tabs);
      });
      //Make the Tabs Sortable
      if (o.sortable) {
        if (
          !$tabs
            .find(".inforTabset a:first")
            .prev()
            .is(".inforDragHandle")
        ) {
          $tabs
            .find(".inforTabset a")
            .before("<div class='inforDragHandle'></div>")
            .disableSelection();
        }
        $tabs
          .find(".inforTabset:first")
          .sortable({
            tolerance: "touch",
            axis: "x",
            forcePlaceholderSize: true,
            handle: ".inforDragHandle",
            placeholder: "inforDragPlaceholder",
            //We can ignore drag on some stuff with
            //items: 'li[id!=dropdownli]',
            start: function(event, ui) {
              ui.item.css("width", "auto").addClass("ui-state-hover");
            },
            stop: function(e, ui) {
              ui.item
                .css({
                  position: "",
                  left: "",
                  top: ""
                })
                .removeClass("ui-state-hover");
              //post action to save tab index
              if (o.sort) {
                o.sort(this, ui, o);
              }
              self._refreshScroll($tabs);
            }
          })
          .disableSelection();
      }
      //handle being in a splitter top pane
      if ($tabs.parent().is("#topPane")) {
        o.fillToBottom = false;
        $tabs.closest(".inforHorizontalSplitter").bind("resize", function(e) {
          $tabs.find(".ui-tabs-panel").height($tabs.parent().height() - 25);
        });
      }
      //handle being in a splitter bottom pane
      if ($tabs.parent().is("#bottomPane")) {
        o.fillToBottom = false;
        $tabs.closest(".inforHorizontalSplitter").bind("resize", function(e) {
          $tabs.find(".ui-tabs-panel").height($tabs.parent().height() - 45);
        });
        $tabs.find(".ui-tabs-panel").height($tabs.parent().height() - 45);
      }
      if (o.verticalTabs) {
        $tabs.addClass("inforVerticalTabs");
      }
      //setup scrolling on the tab control itself.
      if (o.fillToBottom) {
        $tabs.addClass("inforScrollableArea");
        $tabs.inforScrollableArea();
      } else {
        contH = $tabs.height();
        $tabs.find(".ui-tabs-panel").each(function() {
          var panel = $(this);
          //panel.height(contH - 43);
          if (o.verticalTabs) {
            panel.height(contH - 9).css("overflow", "auto");
          }
        });
      }
      //set autowidth
      tabObj = $tabs.tabs({
        /** UPGRADE NOTE:
          `show` is deprecated in jQuery UI 1.9.0 and removed in 1.10.0
          Use the `activate` instead.
          **/
        activate: function(e, ui) {
          var lastOverflow, lastPos, gridOverflow, lastOpenedPanel;
          if (o.animate && !o.verticalTabs) {
            //add cross fade animation
            lastOpenedPanel = $(this).data("lastOpenedPanel");
            if (!$(this).data("topPositionTab")) {
              $(this).data("topPositionTab", $(ui.oldPanel).position().top);
            }
            //Dont use the builtin fx effects. This will fade in/out both tabs, we dont want that
            //Fadein the new tab yourself
            $(ui.oldPanel)
              .hide()
              .fadeIn(400);
            if (lastOpenedPanel) {
              lastOverflow = lastOpenedPanel.css("overflow");
              lastPos = lastOpenedPanel.css("position");
              gridOverflow = lastOpenedPanel
                .find(".slick-viewport")
                .css("overflow");
              lastOpenedPanel.find(".slick-viewport").css("overflow", "hidden");
              // 1. Show the previous opened tab by removing the jQuery UI class
              // 2. Make the tab temporary position:absolute so the two tabs will overlap
              // 3. Set topposition so they will overlap if you go from tab 1 to tab 0
              // 4. Remove position:absolute after animation
              lastOpenedPanel
                .css("overflow", "hidden")
                .toggleClass("ui-tabs-hide")
                .css("position", "absolute")
                .css("top", $(this).data("topPositionTab") + "px")
                .fadeOut(400, function() {
                  var panel = $(this);
                  panel.css("position", lastPos ? lastPos : "");
                  panel.css("overflow", lastOverflow ? lastOverflow : "");
                  self._sizeInternalElements($(ui.oldPanel), $tabs);
                  if (gridOverflow) {
                    panel.find(".slick-viewport").css("overflow", gridOverflow);
                  }
                });
            }
            //Saving the last tab has been opened
            $(this).data("lastOpenedPanel", $(ui.oldPanel));
          }
          $(ui.newPanel)
            .find(".autoLabelWidth")
            .each(function() {
              var container = $(this);
              container.find(".inforLabel, .label").autoWidth();
            });
          self._scrollTabIntoView($tabs, $tabs.find("ul.inforTabset:first"));
          self._sizeInternalElements($(ui.newPanel), $tabs);
          $tabs.trigger("tabsactivate");
        }
      });
      if (o.moduleTabs) {
        $tabs.children(".inforTabset").addClass("inforModuleTabs");
      } else {
        $tabs.children(".inforTabset").addClass("inforNormalTabs");
      }
      //add levels
      parents = $tabs.parents(".ui-tabs").not(".inforModuleTabs");
      if (parents.length > 0) {
        parents
          .find(".inforTabset")
          .not(".level0, .level1, .level2, .level3, .inforModuleTabs")
          .each(function(index) {
            $(this).addClass(
              "level" + ($(this).parents(".ui-tabs-panel").length + 1)
            );
          });
      }
      if (o.verticalTabs) {
        tabObj.addClass("inforVerticalTabs");
        self._sizeVerticalTabs($tabs);
      }
      $tabs
        .find(".ui-tabs-panel:visible")
        .find(".autoLabelWidth")
        .each(function() {
          var container = $(this);
          container.find(".inforLabel").autoWidth();
        });
      //Find context Menus and initialize.
      $tabs.find("ul .inforContextMenu, ul .popupmenu").each(function() {
        var menu = $(this),
          a = menu.prev();
        menu.parent().addClass("downArrow"); // ui-state-disabled
        a.popupmenu(
          {
            menu: menu.attr("id"),
            beforeOpening: function() {
              $(a.attr("href"))
                .find(".inforTabSection")
                .hide();
            },
            position: { my: "left top-1", at: "left bottom", of: a.parent() }
          },
          function(id, a) {
            $("#" + id)
              .parent()
              .children("div")
              .hide();
            $("#" + id).show();
          }
        );
        menu.parent().appendTo("body");
      });
    },
    _sizeInternalElements: function(panel, $tabs) {
      panel.find(".inforDataGrid").each(function() {
        var grid = $(this).data("gridInstance");
        if (grid) {
          grid.reinit();
        }
      });
      panel.find(".ui-tabs").each(function() {
        //nested tabs
        var tab = $(this).data("uiInforTabset");
        if (tab) {
          tab.handleResize(null, true);
        }
      });
      panel.find(".inforSplitter").each(function() {
        var splitter = $(this).data("uiInforSplitter");
        if (splitter) {
          splitter.handleResize(null, true);
        }
      });
      if ($tabs.data("uiInforScrollableArea")) {
        $tabs.data("uiInforScrollableArea")($tabs);
      }
    },
    _setOption: function(key, value) {
      $.Widget.prototype._setOption.apply(this, arguments);
    },
    _addAddButton: function($tabs, o) {
      if (!o.addButton) {
        return;
      }
      var $button = $(
        "<button type='button' class='inforAddTabButton' title='" +
          o.toolTips.addButton +
          "'><span class='rightSlice'></span></button>"
      );
      $tabs.find(".inforTabset").append($button);
      $(".inforAddTabButton").click(function() {
        //Adding a new tab...
        var newId = "#tab" + $tabs.tabs().children().length;
        $tabs.inforTabset("add", newId, "New Tab", true);
      });
    },
    _adjustAddNewButton: function($tabs, o) {
      if (!o.addButton) {
        return;
      }
      //moves this html so its always at the end
      var addTab = $tabs.find(".inforAddTabButton");
      addTab.remove();
      this._addAddButton($tabs, o);
    },
    _addEditors: function($tabs, ui, isNew, o) {
      var list = $tabs.find("ol,ul").eq(0),
        lis = $("li:has(a[href])", list),
        last = null;
      lis.each(function() {
        var $thisA = $(this).find("a");
        last = $thisA;
        //replaces jeditable plugin in much less lines.
        $thisA.dblclick(function() {
          //add a text box to this elem
          var width = $thisA.width(),
            $input = $(
              '<input class="inforTextbox noTrackDirty inforTabHeaderEditor">'
            )
              .val($thisA.text())
              .width(width);
          $thisA.css("opacity", "0").after($input);
          $input.css({
            position: "absolute"
          });
          if (!o.moduleTabs) {
            $input.css({
              left: $thisA.position().left + 2 + "px",
              top: "2px"
            });
          } else {
            $input.css({
              left: $thisA.position().left + 2 + "px",
              top: "5px",
              "font-size": "1.5em"
            });
          }
          //Focus and add events
          $input
            .focus()
            .select()
            .blur(function() {
              var value = $input.val();
              $thisA.css("opacity", "").text(value);
              // execute callback
              if (!isNew && o.rename) {
                o.rename(this, value, o);
              }
              if (isNew && o.add) {
                o.add(this, $input, value, o);
              }
              $input.remove();
              isNew = false;
            });
        });
      });
      if (isNew) {
        last.trigger("dblclick");
      }
    },
    _addMenuToPage: function($tabs, o) {
      var list = $tabs.find("ol,ul").eq(0),
        lis = $("li:has(a[href])", list),
        tabName = "tabs-menu-" + $(".inforTabset").index(list), //used to be $('.inforTabset').length,
        i = 0,
        ul,
        text,
        href,
        tabLi,
        originalIndex;
      // If the menu already exists, reuse it, but empty it.
      if ($("#" + tabName).length > 0) {
        ul = $("#" + tabName);
        ul.empty();
      } else {
        ul = $("<ul class='popupmenu'></ul>").attr("id", tabName);
        $tabs.after(ul);
        $tabs.on("tabsactivate", function(e) {
          $("li a.is-checked", ul).removeClass("is-checked");
          // $tabs.tabs("option", "active") returns inaccurate index
          // because it keeps recently deleted tabs in the list 
          // when getting the active one. 
          var allTabs = $tabs.find('.ui-tabs-nav li');
          var activeTab = allTabs.filter('.ui-tabs-active');
          var selectedIndex = allTabs.index(activeTab)
          if (0 <= selectedIndex) {
            var selectedItem = ul.children().eq(selectedIndex);
            if (selectedItem.length > 0) {
              selectedItem.children("a").addClass("is-checked");
            }
          }
        });
      }
      lis.each(function() {
        var $this = $(this),
          $thisA = $(this).find("a");
        if (!$thisA.parent().hasClass("inforHiddenTab")) {
          text = $thisA.html();
          //do not recreate the href, use the existing href if existing
          if ($thisA.attr("index") == undefined) {
            href = i;
          } else {
            href = $thisA.attr("index") - 1;
          }
          tabLi = $(
            "<li class='" +
              i +
              ($thisA.parent().hasClass("ui-state-disabled")
                ? " disabled"
                : "") +
              "'><a href='#" +
              href +
              "'>" +
              text +
              "</a></li>"
          );
          if ($thisA.data("text")) {
            text = $thisA.data("text");
          }
          tabLi.data("tabItem", $this);
          //ui-state-disabled
          ul.append(tabLi);
        }
        i++;
      });
      //add sort behaviors
      if (o.sortable) {
        $(ul)
          .addClass("connectedSortable")
          .sortable({
            placeholder: "inforDragPlaceholder",
            helper: "clone",
            forcePlaceholderSize: true,
            revert: 100,
            delay: 500,
            connectWith: ".connectedSortable",
            start: function(event, ui) {
              originalIndex = ui.item.index();
            },
            stop: function(event, ui) {
              var elem = ui.item.data("tabItem");
              if (originalIndex == ui.item.index()) {
                return;
              }
              if (ui.originalPosition.top > ui.position.top) {
                list
                  .children()
                  .eq(ui.item.index())
                  .before(elem); //dragged up
              } else {
                list
                  .children()
                  .eq(ui.item.index())
                  .after(elem); //dragged down
              }
              if (o.sort) {
                o.sort(this, ui, o);
              }
            }
          });
      }
      $tabs.trigger("tabsactivate");
      return tabName;
    },
    closeTab: function(tabLi) {
      var tabIndex = tabLi.children("a").attr("href"),
        $tabs = $(this.element),
        self = this,
        o = this.options,
        closeOk;
      if (o.close) {
        closeOk = o.close($tabs, tabIndex, o);
        if (!closeOk) {
          return;
        }
      }
      //Remove tab using UI method
      tabLi.fadeOut(250, function() {
         /** UPGRADE NOTE:
          `.tabs("remove")` is deprecated used .remove() instead
          **/
        var tab = $( ".ui-tabs-nav" ).find( ".ui-tabs-nav li:eq("+tabIndex+")" ).remove();
        var panelId = tab.attr( "aria-controls" );
        $( "#" + panelId ).remove();
        $(this.element).tabs( "refresh" );
        self._refreshScroll($tabs);
      });
    },
    _addCloseButton: function($tabs, o) {
      var list = $tabs.find("ol,ul").eq(0),
        lis = $("li:has(a[href])", list).not(".notClosable"),
        self = this,
        i,
        item,
        menu = $("#inforTabContextMenu");
      if (menu.length === 0) {
        menu = $('<ul id="inforTabContextMenu" class="inforContextMenu"></ul>');
        for (i = 0; i < o.contextMenuOptions.length; i++) {
          item =
            '<li><a href="' +
            o.contextMenuOptions[i].href +
            '">' +
            o.contextMenuOptions[i].label +
            "</a></li>";
          menu.append(item);
        }
        menu.appendTo("body");
      }
      lis.each(function() {
        var $thisLi = $(this);
        if ($thisLi.find(".inforTabCloseButton").length === 0) {
          $thisLi.append(
            $("<button></button>")
              .addClass("inforTabCloseButton")
              .attr("title", o.toolTips.closeButton)
              .on("click", function(e) {
                self.closeTab($(this).parent());
              })
              .append("<span></span>")
          );
          //add right click menu.
          $thisLi.inforContextMenu(
            {
              menu: "inforTabContextMenu"
            },
            function(action, el, pos) {
              var lis = null;
              if (action == "close") {
                self.closeTab(el);
              }
              if (action == "closeOthers") {
                lis = $("li:has(a[href])", $tabs.find("ol,ul").eq(0)).not(
                  ".notClosable"
                );
                lis.not(el).each(function(e) {
                  self.closeTab($(this));
                });
              }
              if (action == "closeAll") {
                lis = $("li:has(a[href])", $tabs.find("ol,ul").eq(0)).not(
                  ".notClosable"
                );
                lis.each(function(e) {
                  self.closeTab($(this));
                });
              }
            }
          );
        }
        //If width not assigned, the hidden tabs width cannot be calculated properly in _adjustLeftPosition
      });
    },
    remove: function(tabId) {
      var $tabs = $(this.element);
      var allTabs = $tabs.find('.ui-tabs-nav li');
      var tab, index;

      if (typeof tabId == "string") {
        // remove by id
        /** UPGRADE NOTE:
        `.tabs("remove")` is deprecated used .remove() instead
        **/
        tab = $('.ui-tabs-nav li a[href=' + tabId + ']').parent();
        var index = allTabs.index(tab);
        tab.remove();
        // Remove the associated tab panel
        var panelId = tab.find('a').attr('aria-controls');
        $('#' + panelId).remove();
      } else {
        // Remove by index
        index = tabId;
        tab = $(".ui-tabs-nav li:eq(" + index + ")").remove();

        // Remove the associated tab panel
        var panelId = tab.find('a').attr('aria-controls');
        $('#' + panelId).remove();
      }
      // If selected tab was removed, focus the tab to the right or, if the last tab was removed, the tab to the left
      allTabs = $tabs.find('.ui-tabs-nav li');
      let newIndex;
      if (tab.hasClass("ui-tabs-active") && allTabs.length > 0) {
        newIndex = index + (index + 1 < allTabs.length ? 1 : -1);
        allTabs.eq(newIndex).find('a').trigger('click');
      }
      
      this._refreshScroll($tabs);
	  },
    add: function(tabId, label, enterEditMode, callback) {
      var $tabs = $(this.element),
        o = this.options,
        id = null,
        callbackEvent = null,
        callbackUi = null;
		if (!tabId.startsWith("#")) {
			tabId = "#" + tabId.replace(/ /g, "_").replace(/\./g, " ");
		}
	
		var tabTemplate = "<li><a href='" + tabId + "'>" + label + "</a></li>";
		var li = $(tabTemplate);
		
		$tabs.find(".ui-tabs-nav").append(li);
		
		var tabContentTemplate = "<div id='" + tabId.substring(1) + "'></div>";
		var tabContent = $(tabContentTemplate);
		$tabs.append(tabContent);
		
		$tabs.tabs("refresh");
	
		
		var newIndex = $tabs.find(".ui-tabs-nav li").length - 1;
		$tabs.tabs("option", "active", newIndex);
      //Add extras.
      this._adjustAddNewButton($tabs, o);
      if (o.closable) {
        this._addCloseButton($tabs, o);
      }
      if (o.sortable) {
        $tabs
          .find('a[href="' + tabId + '"]')
          .before("<div class='inforDragHandle'></div>")
          .disableSelection();
      }
      if (enterEditMode && o.editable) {
        this._addEditors($tabs, this, true, o);
      }
      this._refreshScroll($tabs);
      if (callback) {
        //execute the callback
        callback(callbackEvent, callbackUi);
      }
      $tabs.data("uiInforTabset")._addMenuToPage($tabs, o);
    },
    _addButtons: function($tabs, o) {
      var content = $tabs.find("ul.inforTabset:first"),
        self = this,
        width = 0,
        btnCount = 0,
        oldWidth = 0,
        oldheight,
        moduleButtons = $('<div class="inforTabButton"></div>'),
        chevron = $(
          '<div class="inforTabButton"><button type="button" class="inforMoreButton">' +
            Globalize.localize("More").replace("...", "") +
            "</button></div>"
        );
      if (o.moduleTabs) {
        $tabs
          .find(".inforModuleHeaderRight:first")
          .children()
          .each(function(index, ui) {
            $(ui).appendTo(moduleButtons);
            btnCount++;
          });
      }
      content.after(chevron);
      if (o.moduleTabs) {
        content.after(moduleButtons);
      }
      var menuName = self._addMenuToPage($tabs, o);
      chevron.popupmenu({ menu: menuName }).on("tabsactivate", function(e, el) {
        var action = el.attr("href").substr(1);
        $( ".ui-tabs-nav" ).tabs( "option", "activate", parseInt(action, 10) );
        if (!self.options.moduleTabs) {
          self._scrollTabIntoView($tabs, content);
        }
      });
      chevron.hide().addClass("inforHiddenTab");
      this._refreshScroll($tabs);
      var reinit = function() {
        self._refreshScroll($tabs);
        self._sizeVerticalTabs($tabs);
      };
      this.handleResize = function(e, force) {
        if (self._resizeTimer) {
          clearTimeout(self._resizeTimer);
        }
        if (
          force ||
          self._windowHeight != $(window).height() ||
          self._windowWidth != $(window).width()
        ) {
          self._resizeTimer = setTimeout(reinit, 1);
          self._windowHeight = $(window).height();
          self._windowWidth = $(window).width();
        }
      };
      $(window)
        .unbind("throttledresize.inforTabset" + $tabs[0].id)
        .bind("throttledresize.inforTabset" + $tabs[0].id, this.handleResize);
    },
    _sizeVerticalTabs: function($tabs) {
      $tabs.find("li a").css("width", "auto");
      $tabs
        .find("li a")
        .parent()
        .css("width", "auto");
      var self = this,
        tabWidth = $tabs.find("li:first").width() + 28,
        ul,
        width;
      if (self.options.verticalTabs) {
        ul = $tabs.find("ul:first");
        width = $(window).width() - (ul.width() + ul.position().left + 84);
        $tabs.find("ul:first > li > a").each(function() {
          var lia = $(this);
          lia.width(tabWidth);
          lia.parent().width(tabWidth);
        });
      }
    },
    _scrollTabIntoView: function($tabs, content) {
      /** UPGRADE NOTE:
          `ui-tabs-selected` is deprecated use `ui-tabs-active` instead
          **/
        var sel = $tabs.find(".ui-tabs-active:first"),
        moreWidth = 0, //$tabs.find(".inforMoreButton").parent().width(),
        left = 0,
        toElemOffset,
        totalOffset;
      if (sel.length == 0) {
        return;
      }
      (toElemOffset = sel.position().left + sel.width()),
        (totalOffset = $tabs.position().left + $tabs.width());
      $tabs.find(".inforTabButton").each(function() {
        moreWidth += $(this).width();
      });
      left =
        $tabs.width() -
        content.width() -
        22 +
        (sel.is(":last-child") ? moreWidth - 15 : sel.width());
      if (sel.length < 1) {
        return;
      }
      if (sel.is(":first-child")) {
        left = 0;
      }
      //sel[0].scrollIntoView();  //sort of works...
      //sel.find("a").focus();
      content.css("left", left);
      if (toElemOffset < 0 || toElemOffset < totalOffset) {
        content.css("left", 0);
      }
    },
    _refreshScroll: function($tabs) {
      var self = this;
      var headerWidth = 32,
        self = this,
        tabsWidth = $tabs.width(),
        content = $tabs.find("ul.inforTabset:first"),
        overFlowButton = $tabs.find(".inforMoreButton"),
        maxWidth = content.parent().css("max-width");
      this._addMenuToPage($tabs, self.options);
      //calculate tabs width
      var numTabs = content.find("li").length;
      content.find("li").each(function() {
        // If a tab is opened from search results, for example, the tab header will not have human-readable text.
        // Instead, it will have an empty div. I'm calling that a placeholder tab. The length for such a tab is always 47,
        // which is very likely too small. Therefore, I'm replacing that length with the length of a 'Building Application InfoViewer' tab.
        if (
          self._isPlaceholderTab(
            $(this)
              .find("a")
              .html()
          )
        ) {
          headerWidth += 238; // headerWidth / numTabs;
        } else {
          headerWidth += $(this).outerWidth();
        }
      });
      if (this._isDeployment()) headerWidth += 40;
      if (headerWidth < tabsWidth) {
        overFlowButton.parent().hide();
        $tabs
          .find("ol,ul")
          .eq(0)
          .css("max-width", maxWidth);
        content.css({
          width: "auto",
          left: "0"
        });
      } else {
        overFlowButton
          .parent()
          .show()
          .removeClass("inforHiddenTab");
        content.width(headerWidth + overFlowButton.parent().width() + 20);
        if (maxWidth) {
          content.css("max-width", maxWidth);
        }
        self._scrollTabIntoView($tabs, content);
        //set tooltip on last tab
        $tabs.find("li a").each(function() {
          var a = $(this);
          if (!a.attr("title")) {
            a.attr("title", a.text());
          }
        });
      }
    },
    _isIE6to11: function() {
      // This will return true for IE versions 6 - 11, but false for IE 12 or Edge
      if (
        (/msie/.test(navigator.userAgent.toLowerCase()) ||
          /trident/.test(navigator.userAgent.toLowerCase())) &&
        !/x64|x32/.test(navigator.userAgent.toLowerCase())
      )
        return true;
      return false;
    },
    _isPlaceholderTab: function(tabHeader) {
      // Does the tab header contain readable text or an html element?
      if (!/<[a-z][\s\S]*>/i.test(tabHeader)) return false;
      // If the element's ID is if the overlay, it is a placeholder
      if ($(tabHeader).attr("id") === "inforLoadingOverlay") return true;
      return false;
    },
    _isDeployment: function() {
      // frame sets the runTimeOptions when SetAppPath is called
      if (instance.runTimeOptions.runtimeMode === "Deployment") return true;
      return false;
    }
  });
})(jQuery);
